// OneTrust consent group IDs. Defaults; VERIFY against the published domain
// (see docs/onetrust-sdk-integration-analysis.md §8 / Assumptions #1). Changing
// the tenant's IDs is a single edit here.
export const CATEGORIES = {
  STRICTLY_NECESSARY: 'C0001',
  PERFORMANCE: 'C0002',
  FUNCTIONAL: 'C0003',
  TARGETING: 'C0004',
};
